import UserRankBadge from './UserRankBadge';
import UserRankProgressBar from './UserRankProgressBar';
import '../../Style/userRank.css';

const RANKS = ['UNRANKED', 'IRON', 'BRONZE', 'SILVER', 'GOLD', 'PLATINUM', 'EMERALD', 'DIAMOND'];

function RankPanel({ progress }) {
  if (!progress) return <div>No progress found.</div>;

  // Find the index of the current rank
  const currentIndex = RANKS.indexOf(progress.currentRank);

  // Get the next rank in the list (if it's not the last one)
  const nextRank = currentIndex < RANKS.length - 1 ? RANKS[currentIndex + 1] : 'MAX LEVEL';

  return (
    <div className="glass-card rank-panel">
      <div style={{ textAlign: 'center', borderRight: '1px solid var(--border)' }}>
        <UserRankBadge rank={progress.currentRank} />
        {/* FIXED: Quotes added around var(--primary) */}
        <div style={{ fontWeight: '800', fontSize: '1.2rem', color: 'var(--primary)' }}>
          {progress.currentRank}
        </div>
        <div style={{ fontSize: '0.8rem', color: 'var(--text-sub)' }}>
          {progress.totalXP} Total XP
        </div>
      </div>
      <div>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
          <span style={{ fontWeight: '600' }}>Daily Focus</span>
          <span style={{ color: 'var(--text-sub)' }}>{progress.dailyXP} / 250 XP</span>
        </div>
        <div className="daily-focus-bar">
          <div
            className="focus-bar-color"
            style={{
              /* Use rankProgress if it exists (Public), otherwise use Daily XP math (Home) */
              '--progress': `${Math.min((progress.dailyXP / 250) * 100, 100)}%`,
            }}
          />
        </div>
        <p style={{ fontSize: '0.85rem', color: 'var(--text-sub)', marginTop: '12px' }}>
          Next Rank: <b>{nextRank}</b> • {250 - (progress.dailyXP || 0)} XP to go today
        </p>
      </div>
    </div>
  );
}

export default RankPanel;
